import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Control } from 'react-hook-form';
import { ControlledDropdown } from '../../../components';
import { ListOfValues, LoVNode } from '../../../utils/types';

export default function DropdownList({
  control,
  errors,
  list,
  watch,
  getValues,
  setValue,
}: {
  control: Control;
  errors: any;
  list: LoVNode[] | [];
  watch: any;
  getValues: any;
  setValue: any;
}) {
  const { t } = useTranslation('create_attendance');
  const lov = new ListOfValues(list);

  const [types] = useState(lov.getTypes());
  const [subjects, setSubjects] = useState<{ name: string }[]>([]);
  const [categories, setCategories] = useState<{ name: string }[]>([]);
  const [subCategories, setSubCategories] = useState<{ name: string }[]>([]);

  useEffect(() => {
    setValue('subject', '');
    setValue('category', '');
    setValue('subCategory', '');

    const type = getValues('solicitationType');
    setSubjects(type ? lov.getSubjectsByType(type) : []);
    setCategories([]);
    setSubCategories([]);
  }, [watch('solicitationType')]);

  useEffect(() => {
    setValue('category', '');
    setValue('subCategory', '');

    const subject = getValues('subject');
    setCategories(subject ? lov.getCategoriesBySubjectAndType(getValues('solicitationType'), subject) : []);
    setSubCategories([]);
  }, [watch('subject')]);

  useEffect(() => {
    setValue('subCategory', '');

    const category = getValues('category');
    setSubCategories(
      category
        ? lov.getSubcategoriesByCategorySubjectAndType(getValues('solicitationType'), getValues('subject'), category)
        : [],
    );
  }, [watch('category')]);

  return (
    <>
      <ControlledDropdown
        control={control}
        name="solicitationType"
        rules={{ required: true }}
        actions={types}
        placeholder={t('solicitationTypePlaceholder')}
        errorMessage={t('solicitationTypeErrorMessage')}
        textLabel={t('solicitationType')}
        error={Boolean(errors.solicitationType)}
      />
      <ControlledDropdown
        control={control}
        name="subject"
        rules={{ required: true }}
        actions={subjects}
        placeholder={t('subjectPlaceholder')}
        errorMessage={t('subjectErrorMessage')}
        textLabel={t('subject')}
        error={Boolean(errors.subject)}
        disable={watch('solicitationType') === ''}
      />
      <ControlledDropdown
        control={control}
        name="category"
        rules={{
          required: categories.length > 0,
        }}
        actions={categories}
        placeholder={t('categoryPlaceholder')}
        errorMessage={t('categoryErrorMessage')}
        textLabel={t('category')}
        error={Boolean(errors.category)}
        disable={categories.length === 0}
      />
      <ControlledDropdown
        control={control}
        rules={{
          required: subCategories.length > 0,
        }}
        name="subCategory"
        actions={subCategories}
        placeholder={t('subCategoryPlaceholder')}
        errorMessage={t('subCategoryErrorMessage')}
        textLabel={t('subCategory')}
        error={Boolean(errors.subCategory)}
        disable={subCategories.length === 0}
      />
    </>
  );
}
